import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Tabs } from 'antd';
import { SettingOutlined, EnvironmentOutlined, TagsOutlined, AppstoreOutlined, ShopOutlined, AuditOutlined, LockOutlined } from '@ant-design/icons';
import { hasPermission } from '../../utils/permissions';
import DeliveryAddress from './DeliveryAddress/DeliveryAddress';
import UdhyamCategory from './UdhyamCategory/UdhyamCategory';
import ProductCategory from './ProductCategory/ProductCategory';
import FirmName from './FirmName/FirmName';
import ApprovalConfig from './ApprovalConfig/ApprovalConfig';
import './SiteConfigurations.css';

const SiteConfigurations = () => {
  // Get permissions from Redux store
  const permissions = useSelector(state => state.auth.permissions || []);

  // Define all possible tabs with their permission requirements
  const allTabItems = [
    {
      key: 'delivery-address',
      label: (
        <span>
          <EnvironmentOutlined />
          Delivery Address
        </span>
      ),
      children: <DeliveryAddress />,
      permission: 'delivery_address/view' // Specific permission
    },
    {
      key: 'udhyam-category',
      label: (
        <span>
          <TagsOutlined />
          Udhyam Category
        </span>
      ),
      children: <UdhyamCategory />,
      permission: 'udhyam_category/view'
    },
    {
      key: 'product-category',
      label: (
        <span>
          <AppstoreOutlined />
          Product Category
        </span>
      ),
      children: <ProductCategory />,
      permission: 'product_category/view'
    },
    {
      key: 'firm-name',
      label: (
        <span>
          <ShopOutlined />
          Firm Name
        </span>
      ),
      children: <FirmName />,
      permission: 'firm_name/view'
    },
    {
      key: 'approval-workflow',
      label: (
        <span>
          <AuditOutlined />
          Approval Workflow
        </span>
      ),
      children: <ApprovalConfig />,
      permission: null, // admin-only enforced inside the component via AdminMiddleware on the PUT
    }
  ];

  // Filter tabs based on permissions
  const visibleTabItems = useMemo(() => {
    return allTabItems.filter(tab =>
      !tab.permission || hasPermission(permissions, tab.permission)
    );
  }, [permissions]);

  // Get the first visible tab key for default
  const defaultActiveKey = visibleTabItems.length > 0 ? visibleTabItems[0].key : '';

  return (
    <div className="page-container">
      <div className="page-content">
        {/* Page Header */}
        <div className="page-header">
          <div className="page-header-title">
            <div className="page-header-icon"><SettingOutlined /></div>
            <div className="page-header-text">
              <h1>Site Configurations</h1>
              <p>Manage your application settings and configurations</p>
            </div>
          </div>
        </div>

        {/* Configuration Tabs */}
        <div className="card">
          {visibleTabItems.length > 0 ? (
            <Tabs
              type="card"
              size="large"
              defaultActiveKey={defaultActiveKey}
              items={visibleTabItems}
              tabPosition="top"
              style={{ padding: '1rem' }}
            />
          ) : (
            <div className="empty-state">
              <div className="empty-state-icon"><LockOutlined /></div>
              <div className="empty-state-text">
                You don't have permission to view any configuration sections.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SiteConfigurations;